import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import {
  USER_RESTORE,
  USER_LIST,
  USER_DELETE,
  USER_LIST_DROPDOWN,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CITY_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  CATEGORY_LIST_DROPDOWN,
  BUSINESS_SUB_CATEGORY_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  USER_CHANGE_CHAPTER,
  USER_MEMBERSHIP_RENEWAL,
  USER_MEMBERSHIP_RENEWAL_LOGS,
  USER_IMPORT,
  USER_SEND_WELCOME_EMAILS,
  USER_ROLE_LIST_DROPDOWN,
  baseUrl,
  USER_MEMBER_LOGS,
  // MEMBER_CROWN_LIST_DROPDOWN, // Client: Crowns paused
  // MEMBER_TYPE_LIST_DROPDOWN,
} from "../../routes/routes";
import {
  PAGINATE,
  NOPAGINATE,
  USER_DELETED,
  USER_CHAPTER_CHANGED,
} from "../../constant/constant";
import { toast } from "react-toastify";
import {
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
  renderMemberLogTypeBadge,
  getMemberBreakPeriodText,
} from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Link, useNavigate } from "react-router-dom";
import { Modal, Image } from "react-bootstrap";
import userIcon from "../../assets/images/user_icon.png";
import { FaFileExcel } from "react-icons/fa";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import { ValidationMessage, hasRole } from "../../components/Utils";
import moment from "moment";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { styleExcelHeaderRow } from "../../utils/excelStyles";
// import { jsPDF } from "jspdf";
import "jspdf-autotable";
import StickyTable from "../../components/common/StickyTable";
import sampleExcel from "../../assets/excel/sample-members.xlsx";

const formatPhoneWithCode = (code, number) => {
  if (!number) return "";
  return `+${code || "91"} ${number}`;
};

const getDriveImageUrl = (urlObj) => {
  if (!urlObj) return "";
  let urlStr = urlObj;
  if (typeof urlObj === "object") {
    urlStr = urlObj.hyperlink || urlObj.text || "";
  }
  if (typeof urlStr !== "string") return "";
  if (urlStr.includes("drive.google.com")) {
    const idMatch = urlStr.match(/[?&]id=([^&]+)/);
    if (idMatch && idMatch[1]) {
      return `https://drive.google.com/thumbnail?id=${idMatch[1]}&sz=w200`;
    }
    const pathMatch = urlStr.match(/\/file\/d\/([^\/]+)/);
    if (pathMatch && pathMatch[1]) {
      return `https://drive.google.com/thumbnail?id=${pathMatch[1]}&sz=w200`;
    }
  }
  return urlStr;
};

/** Plain text from Excel cell (handles hyperlink / mailto objects) */
const getCellText = (cell) => {
  if (cell === null || cell === undefined || cell === "") return "";
  if (typeof cell === "number" || typeof cell === "boolean") return String(cell);
  if (cell instanceof Date) return cell.toLocaleDateString();
  let value = cell;
  if (typeof cell === "object") {
    value = cell.text ?? cell.hyperlink ?? cell.result ?? "";
    if (typeof value === "object" && value !== null) {
      value = value.text ?? value.hyperlink ?? "";
    }
    if (Array.isArray(cell.richText)) {
      value = cell.richText.map((t) => t.text || "").join("");
    }
  }
  let str = String(value ?? "").trim();
  if (/^mailto:/i.test(str)) {
    str = str.replace(/^mailto:/i, "").split("?")[0].trim();
  }
  return str;
};


const UserList = () => {
  // ## State Variable Declaration
  const { hasPermission } = usePermission();
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [loading, setLoading] = useState(true);
  const [modalLoading, setModalLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [userOptions, setUserOptions] = useState({});
  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);
  const [showMemberLogs, setShowMemberLogs] = useState(false);
  const [memberLogs, setMemberLogs] = useState([]);
  const [memberLogsLoading, setMemberLogsLoading] = useState(false);
  const [chapterChangeModal, setChapterChangeModal] = useState(false);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [cityOptions, setCityOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [allChapterOptions, setAllChapterOptions] = useState({});
  const [categoryOptions, setCategoryOptions] = useState({});
  const [subCategoryOptions, setSubCategoryOptions] = useState({});
  const [roleOptions, setRoleOptions] = useState({});
  // const [memberTypeOptions, setMemberTypeOptions] = useState({});
  // const [crownOptions, setCrownOptions] = useState([]); // Client: Crowns paused
  const [btnExcelDisabled, setBtnExcelDisabled] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importLoading, setImportLoading] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [emailModal, setEmailModal] = useState(false);
  const [emailStats, setEmailStats] = useState(null);
  const [emailLoading, setEmailLoading] = useState(false);
  const [renewalModal, setRenewalModal] = useState(false);
  const [renewalForm, setRenewalForm] = useState({
    user_id: "",
    member_id: "",
    name: "",
    chapter_name: "",
    current_due_date: "",
    payment_date: moment().format("DD/MM/YYYY"),
    membership_duration_years: 1,
    amount_paid: "",
    payment_mode: "",
    transaction_ref_no: "",
    new_due_date: "",
    notes: "",
  });
  const [renewalErrors, setRenewalErrors] = useState({});
  const [renewalSubmitting, setRenewalSubmitting] = useState(false);
  const [renewalLogs, setRenewalLogs] = useState([]);
  const [renewalLogsLoading, setRenewalLogsLoading] = useState(false);
  const [renewalFiles, setRenewalFiles] = useState([]);
  const [renewalFileKey, setRenewalFileKey] = useState(0);
  const [showRenewalLogs, setShowRenewalLogs] = useState(false);
  const [renewalAttachmentPreview, setRenewalAttachmentPreview] = useState(null);
  const [renewalAttachmentType, setRenewalAttachmentType] = useState(null);
  const [filter, setFilter] = useState([]);
  const [deletedFilter, setDeletedFilter] = useState("all");
  const selectStateRef = useRef(null);
  const selectCityRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);
  const selectMemberRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectCityRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
    selectMemberRef.current.clearValue();
  };

  const handleCityClear = () => {
    selectCityRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
    selectMemberRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
    selectMemberRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
    selectMemberRef.current.clearValue();
  };

  const handleMemberClear = () => {
    selectMemberRef.current.clearValue();
  };

  const membershipStatusOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "In-Active" },
  ];

  // const genderOptions = [
  //   { value: "male", label: "Male" },
  //   { value: "female", label: "Female" },
  // ];

  // const auth_user = JSON.parse(localStorage.getItem("user"));
  // const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  // const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;
  // const isChapterAdmin = auth_user?.user_type === 3 ? 1 : 0;

  const columns = [
    { header: "Sl.No.", key: "sno" },
    { header: "Member ID", key: "member_id" },
    { header: "Name", key: "name" },
    { header: "Email", key: "email" },
    { header: "Mobile Number", key: "mobile_number" },
    { header: "Whatsapp Mobile Number", key: "whatsapp_mobile_number" },
    { header: "Company name", key: "company_name" },
    { header: "Address", key: "address" },
    { header: "Bio Description", key: "bio_description" },
    { header: "Our Products and Services", key: "our_products_and_services" },
    { header: "Date of Birth", key: "dob" },
    { header: "Blood Group Name", key: "blood_group_name" },
    { header: "GST Number", key: "gst" },
    { header: "Pan Number", key: "pan" },
  ];
  if (hasRole([1])) {
    columns.push({ header: "Country", key: "country_name" });
  }
  if (hasRole([1, 6])) {
    columns.push({ header: "State", key: "state_name" });
  }
  if (hasRole([1, 6, 7])) {
    columns.push({ header: "City", key: "city_name" });
  }
  if (hasRole([1, 6, 7, 8])) {
    columns.push({ header: "Region", key: "region_name" });
  }
  if (hasRole([1, 6, 7, 8, 2])) {
    columns.push({ header: "Circle", key: "chapter_name" });
  }
  columns.push(
    // { header: "Member Type", key: "member_type_name" },
    { header: "User Role", key: "user_role_name" },
    { header: "Category", key: "category_name" },
    { header: "Sub Category", key: "sub_category_name" },
    { header: "Payment Date", key: "payment_date" },
    { header: "Date of Joining", key: "date_of_joining" },
    { header: "Membership Duration (Years)", key: "membership_duration_years" },
    // { header: "Member Crowns", key: "crowns_name" }, // Client: Crowns paused
    { header: "Membership Due Date", key: "membership_due_date" },
    { header: "Welcome Email Sent", key: "is_welcome_email_sent_text" },
    { header: "Website", key: "website" },
    { header: "Instagram Url", key: "instagram_url" },
    { header: "Linkedin Url", key: "linkedin_url" },
    { header: "Twitter Url", key: "twitter_url" },
    { header: "Youtube Url", key: "youtube_url" },
    { header: "Referred By", key: "referred_by_text" },
    { header: "Referrer Name", key: "referrer_name" },
    { header: "Referrer Mobile Number", key: "referrer_mobile" },
    { header: "Membership Status", key: "membership_status_text" },
  );

  const currentDate = moment().format("DD-MM-YYYY");
  const workSheetName = `Members ( ${currentDate} )`;
  const workBookName = "Members List";

  const workbook = new Excel.Workbook();

  const exportAsExcel = async () => {
    try {
      const fileName = workBookName;
      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;
      // updated the font and fill for header row cells.
      const headerRow = worksheet.getRow(1);
      styleExcelHeaderRow(headerRow, columns.length);

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 15;
        column.alignment = { horizontal: "center" };
      });
      setBtnExcelDisabled(true);
      await axios
        .get(USER_LIST, {
          params: {
            paging_type: NOPAGINATE,
            isAdmin: 1,
            deleted: deletedFilter,
            ...filter,
          },
        })
        .then(async (response) => {
          if (response.status === 200 && response.data.success) {
            const excelData = response.data.data.users;

            if (excelData.length < 1) {
              toast.error("No data found!.");
              return;
            }

            // loop through data and add each one to worksheet
            excelData.forEach((singleData) => {
              worksheet.addRow({
                ...singleData,
                mobile_number: formatPhoneWithCode(
                  singleData.mobile_country_code,
                  singleData.mobile_number,
                ),
                whatsapp_mobile_number: formatPhoneWithCode(
                  singleData.whatsapp_country_code,
                  singleData.whatsapp_mobile_number,
                ),
              });
            });

            // loop through all of the rows and set the outline style.
            worksheet.eachRow({ includeEmpty: false }, (row) => {
              // store each cell to currentCell
              const currentCell = row._cells;
              // loop through currentCell to apply border only for the non-empty cell of excel
              currentCell.forEach((singleCell) => {
                // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
                const cellAddress = singleCell._address;
                console.log(singleCell);
                // apply border
                worksheet.getCell(cellAddress).border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              });
            });

            // write the content using writeBuffer
            const buf = await workbook.xlsx.writeBuffer();
            // download the processed file
            saveAs(new Blob([buf]), `${fileName}.xlsx`);
          }
        })
        .finally(() => {
          setBtnExcelDisabled(false);
        });
    } catch (error) {
      console.error("<<<ERRROR>>>", error);
      console.error("Something Went Wrong", error.message);
      toast.error(error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };
  //end

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setImportFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const buffer = e.target.result;
          const workbook = new Excel.Workbook();
          await workbook.xlsx.load(buffer);
          const worksheet = workbook.worksheets[0];
          let rowData = [];
          worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 1) {
              // ExcelJS row.values is 1-indexed; capture hyperlinks for every column
              const values = [...row.values];
              row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                if (cell.hyperlink) {
                  values[colNumber] = {
                    hyperlink: cell.hyperlink,
                    text:
                      cell.text ||
                      (typeof cell.value === "string"
                        ? cell.value
                        : cell.value?.text) ||
                      "",
                  };
                } else if (
                  cell.value &&
                  typeof cell.value === "object" &&
                  !(cell.value instanceof Date)
                ) {
                  values[colNumber] = cell.value;
                }
              });
              const rowName = getCellText(values[1]);
              const rowEmail = getCellText(values[2]);
              const rowMobile = getCellText(values[3]);
              if (rowName.trim() !== "" || rowEmail.trim() !== "" || rowMobile.trim() !== "") {
                rowData.push(values);
              }
            }
          });
          setPreviewData(rowData);
        } catch (error) {
          console.error("Error reading excel file:", error);
          toast.error("Failed to read excel file for preview.");
          setPreviewData([]);
        }
      };
      reader.readAsArrayBuffer(file);
    } else {
      setPreviewData([]);
    }
  };

  const handleImportSubmit = async (e) => {
    e.preventDefault();
    if (!importFile) {
      toast.error("Please select an excel file to import.");
      return;
    }
    setImportLoading(true);
    setBtnDisabled(true);
    const formData = new FormData();
    formData.append("file", importFile);

    try {
      const res = await axios.post(USER_IMPORT, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if ((res.status === 200 || res.status === 201) && res.data.success) {
        toast.success(res.data.message || res.data.msg || "Members imported successfully");
        setImportModal(false);
        setImportFile(null);
        setPreviewData([]);
        setRefresh((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
      if (err.response && err.response.data && err.response.data.msg) {
        toast.error(err.response.data.msg, { autoClose: 15000 });
      } else if (
        err.response &&
        err.response.data &&
        err.response.data.message
      ) {
        toast.error(err.response.data.message, { autoClose: 15000 });
      } else {
        toast.error("An error occurred during import.", { autoClose: 15000 });
      }
    } finally {
      setImportLoading(false);
      setBtnDisabled(false);
    }
  };

  const navigate = useNavigate();
  const HandleDelete = async (userId) => {
    try {
      axios
        .delete(USER_DELETE + userId)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success(USER_DELETED);
            setRefresh((prevRefresh) => !prevRefresh);
            navigate("/users");
          }
        })
        .catch((err) => {
          if (err.response.status === 422) {
            toast.error(err.response.data.msg);
          }
        });
    } catch (error) {
      // Handle errors
      console.error(error);
    }
  };

  const HandleRestore = async (userId) => {
    try {
      const res = await axios.post(USER_RESTORE + userId);
      if (res.status === 200 && res.data?.success) {
        toast.success("Member restored successfully!");
        setRefresh((prevRefresh) => !prevRefresh);
      } else {
        toast.error(res?.data?.msg || "Failed to restore member.");
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.msg ||
          err?.message ||
          "Failed to restore member."
      );
    }
  };

  const handleOpenEmailModal = async () => {
    setEmailModal(true);
    setEmailStats({
      totalNeeded: 0,
      sentCount: 0,
      failedCount: 0,
      pendingCount: 0,
    });
    try {
      const auth_user_token = localStorage
        .getItem("token")
        ?.replace(/['"]+/g, "");
      const res = await axios.get(
        baseUrl + "/users/pending-welcome-emails-count",
        {
          headers: { Authorization: `Bearer ${auth_user_token}` },
        },
      );
      if (res.data && res.data.success) {
        setEmailStats({
          totalNeeded: res.data.data.totalNeeded,
          sentCount: 0,
          failedCount: 0,
          pendingCount: res.data.data.totalNeeded,
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch pending emails count.");
    }
  };

  const handleSendWelcomeEmails = async () => {
    setEmailLoading(true);
    try {
      const auth_user_token = localStorage
        .getItem("token")
        ?.replace(/['"]+/g, "");
      const response = await fetch(`${baseUrl}${USER_SEND_WELCOME_EMAILS}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${auth_user_token}`,
        },
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");

      let doneReading = false;
      while (!doneReading) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk.split("\n");
        for (const line of lines) {
          if (line.startsWith("data: ")) {
            const dataStr = line.substring(6).trim();
            if (dataStr) {
              const data = JSON.parse(dataStr);
              if (data.error) {
                toast.error(data.error);
                setEmailLoading(false);
                doneReading = true;
              } else {
                setEmailStats(data);
                if (data.isDone) {
                  setEmailLoading(false);
                  doneReading = true;
                  toast.success("Welcome emails sent successfully!", {
                    autoClose: 3000,
                  });
                }
              }
            }
          }
        }
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to send welcome emails.");
      setEmailModal(false);
      setEmailLoading(false);
    }
  };

  const updateChapterSubmit = () => {
    setModalLoading(true);
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .post(USER_CHANGE_CHAPTER, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setChapterChangeModal(false);
          setRefresh((prevRefresh) => !prevRefresh);
          toast.success(USER_CHAPTER_CHANGED);
          navigate("/users");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        // setModalLoading(false);
        setBtnDisabled(false);
      });
  };

  const calculateNewDueDate = (baseDueDate, years) => {
    if (!baseDueDate) {
      return moment().add(Number(years) || 1, "years").format("DD/MM/YYYY");
    }
    // Parse DD/MM/YYYY or DD/MM/YYYY
    let base = moment(baseDueDate, ["DD/MM/YYYY", "DD-MM-YYYY", "DD/MM/YYYY"]);
    if (!base.isValid()) {
      base = moment();
    }
    return base.clone().add(Number(years) || 1, "years").format("DD/MM/YYYY");
  };

  const fetchRenewalLogs = (userId) => {
    if (!userId) return;
    setRenewalLogsLoading(true);
    axios
      .get(`${USER_MEMBERSHIP_RENEWAL_LOGS}${userId}`)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setRenewalLogs(res.data.data || []);
        } else {
          setRenewalLogs([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setRenewalLogs([]);
      })
      .finally(() => {
        setRenewalLogsLoading(false);
      });
  };

  const handleOpenRenewalModal = (user) => {
    const rawDueDate = user?.membership_due_date || "";
    const calcDueDate = calculateNewDueDate(rawDueDate, 1);
    setRenewalForm({
      user_id: user?.id,
      member_id: user?.member_id,
      name: user?.name,
      chapter_name: user?.chapter_name,
      profile_image: user?.profile_image,
      current_due_date: rawDueDate,
      payment_date: moment().format("DD/MM/YYYY"),
      membership_duration_years: 1,
      amount_paid: "",
      payment_mode: "",
      new_due_date: calcDueDate,
      notes: "",
      attachment: null,
    });
    setRenewalAttachmentPreview(null);
    setRenewalAttachmentType(null);
    setRenewalErrors({});
    setRenewalFiles([]);
    setRenewalFileKey((prev) => prev + 1);
    setShowRenewalLogs(false);
    setRenewalLogs([]);
    setRenewalModal(true);
  };

  const handleToggleRenewalLogs = () => {
    if (!showRenewalLogs) {
      fetchRenewalLogs(renewalForm.user_id);
    }
    setShowRenewalLogs((prev) => !prev);
  };

  const fetchMemberLogs = (userId) => {
    if (!userId) return;
    setMemberLogsLoading(true);
    axios
      .get(USER_MEMBER_LOGS + userId)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setMemberLogs(res.data.data || []);
        } else {
          setMemberLogs([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setMemberLogs([]);
      })
      .finally(() => {
        setMemberLogsLoading(false);
      });
  };

  const handleToggleMemberLogs = () => {
    if (!showMemberLogs) {
      fetchMemberLogs(detailData?.id);
    }
    setShowMemberLogs((prev) => !prev);
  };

  const handleRenewalFieldChange = (field, value) => {
    const updatedForm = { ...renewalForm, [field]: value };
    if (field === "membership_duration_years") {
      updatedForm.new_due_date = calculateNewDueDate(
        renewalForm.current_due_date,
        value
      );
    }
    setRenewalForm(updatedForm);
    if (renewalErrors[field]) {
      setRenewalErrors({ ...renewalErrors, [field]: null });
    }
  };

  const handleRenewalAttachmentChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "application/pdf",
      ];
      const allowedExtensions = [".jpg", ".jpeg", ".png", ".webp", ".pdf"];
      const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(ext)) {
        setRenewalErrors((prev) => ({
          ...prev,
          attachment: "Only images (JPG, PNG, WEBP) and PDF files are allowed",
        }));
        e.target.value = "";
        setRenewalAttachmentPreview(null);
        setRenewalAttachmentType(null);
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        setRenewalErrors((prev) => ({
          ...prev,
          attachment: "File size exceeds 10MB limit",
        }));
        e.target.value = "";
        setRenewalAttachmentPreview(null);
        setRenewalAttachmentType(null);
        return;
      }
      const isPdf = file.type === "application/pdf" || ext === ".pdf";
      setRenewalErrors((prev) => ({ ...prev, attachment: null }));
      setRenewalForm((prev) => ({ ...prev, attachment: file }));
      setRenewalAttachmentType(isPdf ? "pdf" : "image");
      setRenewalAttachmentPreview(URL.createObjectURL(file));
    } else {
      setRenewalForm((prev) => ({ ...prev, attachment: null }));
      setRenewalAttachmentPreview(null);
      setRenewalAttachmentType(null);
    }
  };

  const handleRenewalSubmit = (e) => {
    if (e) e.preventDefault();
    const errors = {};
    if (!renewalForm.payment_date) errors.payment_date = "Payment Date is required";
    if (!renewalForm.membership_duration_years)
      errors.membership_duration_years = "Duration is required";

    if (renewalFiles.length > 3) {
      errors.attachments = "Maximum 3 files can be uploaded";
    }

    if (Object.keys(errors).length > 0) {
      setRenewalErrors(errors);
      return;
    }

    const formData = new FormData();
    Object.keys(renewalForm).forEach((key) => {
      if (renewalForm[key] !== null && renewalForm[key] !== undefined) {
        formData.append(key, renewalForm[key]);
      }
    });

    setRenewalSubmitting(true);
    axios
      .post(USER_MEMBERSHIP_RENEWAL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success("Membership renewed successfully!");
          setRenewalModal(false);
          setRefresh((prev) => !prev);
        } else {
          toast.error(res.data.msg || "Failed to renew membership");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          const error = err.response.data.error;
          setRenewalErrors(error);
          toast.error(err.response.data.msg || "Validation error");
        } else {
          toast.error(
            err.response?.data?.msg ||
              err.message ||
              "Something went wrong while renewing"
          );
        }
      })
      .finally(() => {
        setRenewalSubmitting(false);
      });
  };

  /**
   * @API User List API's call
   */
  useEffect(() => {
    setLoading(true);
    const fetchUsers = async () => {
      try {
        const response = await axios.get(USER_LIST, {
          params: {
            paging_type: PAGINATE,
            page: page,
            perPage: perPage,
            isAdmin: 1,
            deleted: deletedFilter,
            ...filter,
          },
        });
        if (response.status === 200 && response.data.success) {
          const users = response.data.data.users || [];
          const paginatorData = {
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          };

          setData(users);
          setPaginator(paginatorData);
        }
      } catch (err) {
        console.error("Error fetching members:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();

    const fetchData = async () => {
      try {
        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {
            ...filter,
            exclude_other_region_chapter_users: 1,
          },
        });
        const fetchedUserOptions = userResponse.data.data;
        setUserOptions(fetchedUserOptions);

        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        const cityResponse = await axios.get(CITY_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        setCityOptions(cityResponse.data.data);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);

        // Fetch chapter data
        const allchapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            show_all: 1,
          },
        });
        const fetchedAllChapterOptions = allchapterResponse.data.data;
        setAllChapterOptions(fetchedAllChapterOptions);

        // Fetch category data
        const categoryResponse = await axios.get(CATEGORY_LIST_DROPDOWN);
        const fetchedCategoryOptions = categoryResponse.data.data;
        setCategoryOptions(fetchedCategoryOptions);

        const subCategoryResponse = await axios.get(
          BUSINESS_SUB_CATEGORY_LIST_DROPDOWN,
        );
        setSubCategoryOptions(subCategoryResponse.data.data);

        const roleResponse = await axios.get(USER_ROLE_LIST_DROPDOWN);
        setRoleOptions(roleResponse.data.data);

        // const crownResponse = await axios.get(MEMBER_CROWN_LIST_DROPDOWN);
        // setCrownOptions(crownResponse.data.data || []); // Client: Crowns paused

        // Fetch member type data
        // const memberTypeResponse = await axios.get(MEMBER_TYPE_LIST_DROPDOWN);
        // const fetchedMemberTypeOptions = memberTypeResponse.data.data;
        // setMemberTypeOptions(fetchedMemberTypeOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [page, filter, deletedFilter, refresh, perPage]);

  const totalColumns =
    11 +
    (hasRole([1]) ? 1 : 0) +
    (hasRole([1, 6]) ? 1 : 0) +
    (hasRole([1, 6, 7]) ? 1 : 0) +
    (hasRole([1, 6, 7, 8]) ? 1 : 0) +
    (hasRole([1, 6, 7, 8, 2]) ? 1 : 0) +
    2;

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Members</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Members List</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                {hasPermission("members-create") && (
                  <Link to={"/user/create"}>
                    <button
                      type="button"
                      className="btn rounded-pill btn-primary ibutton"
                    >
                      <span className="tf-icons bx bx-plus"></span>&nbsp; Add
                    </button>
                  </Link>
                )}
                {hasPermission("members-list-export") && (
                  <button
                    disabled={btnExcelDisabled}
                    type="button"
                    onClick={exportAsExcel}
                    className="btn rounded-pill btn-primary excel-btn ibutton"
                  >
                    <span className="tf-icons bx bxs-spreadsheet"></span>&nbsp;
                    Excel
                  </button>
                )}
                {hasPermission("members-create") && (
                  <button
                    type="button"
                    onClick={() => setImportModal(true)}
                    className="btn rounded-pill btn-primary excel-btn ibutton ms-2"
                  >
                    <span className="tf-icons bx bx-upload"></span>&nbsp; Import
                  </button>
                )}
                {/* {hasPermission("members-create") && (
                  <button
                    type="button"
                    onClick={handleOpenEmailModal}
                    className="btn rounded-pill btn-primary excel-btn ibutton ms-2"
                  >
                    <span className="tf-icons bx bx-envelope"></span>&nbsp; Send
                    Welcome Emails
                  </button>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          {/* <div className="card-header">
            <h5>Members List</h5>
          </div> */}

          <div className="container-fluid f_containter">
            <div className="row mb-4">
              {hasRole([1]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      setFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        city_id: null,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleCityClear();
                      setFilter({
                        ...filter,
                        state_id: selected?.value,
                        city_id: null,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="city_id">
                    City
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectCityRef}
                    name="city_id"
                    isClearable
                    options={cityOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      setFilter({
                        ...filter,
                        city_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7, 8]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="region_id">
                    Region
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectRegionRef}
                    name="region_id"
                    isClearable
                    options={regionOptions}
                    onChange={(selected) => {
                      handleChapterClear();
                      setFilter({
                        ...filter,
                        region_id: selected?.value,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7, 8, 2]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="chapter_id">
                    Circle
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectChapterRef}
                    name="chapter_id"
                    isClearable
                    options={chapterOptions}
                    onChange={(selected) => {
                      handleMemberClear();
                      setFilter({
                        ...filter,
                        chapter_id: selected?.value,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {/* <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="member_type">
                  Member Type
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="member_type"
                  isClearable
                  options={memberTypeOptions}
                  onChange={(selected) =>
                    setFilter({ ...filter, member_type: selected?.value })
                  }
                />
              </div> */}

              {/* <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="gender">
                  Gender
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="gender"
                  inputId="gender"
                  isClearable
                  options={genderOptions}
                  value={
                    genderOptions.find(
                      (option) => option.value === filter.gender,
                    ) || null
                  }
                  onChange={(selected) => {
                    setPage(1);
                    setFilter({ ...filter, gender: selected?.value });
                  }}
                />
              </div> */}

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="user_id">
                  Member
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  ref={selectMemberRef}
                  name="user_id"
                  isClearable
                  options={userOptions}
                  onChange={(selected) =>
                    setFilter({ ...filter, user_id: selected?.value })
                  }
                />
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="category_id">
                  Category
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="category_id"
                  isClearable
                  options={categoryOptions}
                  onChange={(selected) =>
                    setFilter({
                      ...filter,
                      category_id: selected?.value,
                      sub_category_id: null,
                    })
                  }
                />
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="user_role_id">
                  User Role
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="user_role_id"
                  isClearable
                  options={roleOptions}
                  onChange={(selected) =>
                    setFilter({
                      ...filter,
                      user_role_id: selected?.value,
                    })
                  }
                />
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="sub_category_id">
                  Sub Category
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="sub_category_id"
                  isClearable
                  options={
                    Array.isArray(subCategoryOptions)
                      ? subCategoryOptions.filter(
                          (option) =>
                            !filter.category_id ||
                            option.parent_id === Number(filter.category_id),
                        )
                      : []
                  }
                  value={
                    Array.isArray(subCategoryOptions)
                      ? subCategoryOptions.find(
                          (option) =>
                            option.value === Number(filter.sub_category_id),
                        ) || null
                      : null
                  }
                  onChange={(selected) =>
                    setFilter({
                      ...filter,
                      sub_category_id: selected?.value,
                    })
                  }
                />
              </div>

              {/* Client: Crowns paused
              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="crowns">
                  Member Crowns
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="crowns"
                  isClearable
                  options={crownOptions}
                  onChange={(selected) => {
                    setPage(1);
                    setFilter({ ...filter, crowns: selected?.value });
                  }}
                />
              </div>
              */}

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="status_id">
                  Membership Status
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="status_id"
                  isClearable
                  options={membershipStatusOptions}
                  onChange={(selected) =>
                    setFilter({ ...filter, status_id: selected?.value })
                  }
                />
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="is_welcome_email_sent">
                  Welcome Email Sent
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="is_welcome_email_sent"
                  isClearable
                  options={[
                    { value: "1", label: "Yes" },
                    { value: "0", label: "No" },
                  ]}
                  onChange={(selected) =>
                    setFilter({
                      ...filter,
                      is_welcome_email_sent: selected?.value,
                    })
                  }
                />
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="deleted_filter">
                  Deleted Members
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="deleted_filter"
                  inputId="deleted_filter"
                  options={[
                    { value: "all", label: "All" },
                    { value: "no", label: "No" },
                    { value: "yes", label: "Yes" },
                  ]}
                  value={{
                    value: deletedFilter,
                    label:
                      deletedFilter === "yes"
                        ? "Yes"
                        : deletedFilter === "no"
                        ? "No"
                        : "All",
                  }}
                  onChange={(selected) => {
                    setPage(1);
                    setDeletedFilter(selected?.value || "all");
                  }}
                />
              </div>

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="search">
                    Search
                  </label>
                  <input
                    type="text"
                    className="form-control hide-arrow"
                    id="search"
                    placeholder="Search by Member ID, Name, Mobile Number"
                    onChange={(e) =>
                      setFilter({ ...filter, search: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Note row below filters and above table */}
          {deletedFilter !== "no" && (
            <div
              className="d-flex align-items-center justify-content-between flex-wrap px-3 py-2 mb-3"
              style={{
                backgroundColor: "#fff6f6",
                border: "1px solid #fed7d7",
                borderLeft: "4px solid #ff3e1d",
                borderRadius: "8px",
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <span
                  className="badge bg-label-danger d-inline-flex align-items-center px-2 py-1"
                  style={{ fontSize: "11px", fontWeight: "600" }}
                >
                  <i
                    className="bx bx-info-circle me-1"
                    style={{ fontSize: "14px" }}
                  ></i>
                  Note
                </span>
                <span
                  style={{
                    fontSize: "13px",
                    color: "#566a7f",
                    fontWeight: "500",
                  }}
                >
                  Rows highlighted in light red indicate deleted members.
                </span>
              </div>
            </div>
          )}

          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}

          <StickyTable refreshDeps={[data, loading]}>
            <table className="table table-striped itable table-freeze-action">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Profile Image</th>
                  <th>Member ID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  {/* <th>Member Type</th> */}
                  <th>Category</th>
                  <th>Sub Category</th>
                  <th>Membership Status</th>
                  <th>Date of Joining</th>
                  <th>Membership Due Date</th>
                  <th>Welcome Email Sent</th>
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>City</th>}
                  {hasRole([1, 6, 7, 8]) && <th>Region</th>}
                  {hasRole([1, 6, 7, 8, 2]) && <th>Circle</th>}
                  <th className="sticky-renewal-col" style={{ textAlign: "center", minWidth: "110px" }}>Renewal</th>
                  <th className="sticky-action-col" style={{ textAlign: "center", minWidth: "180px" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan={String(totalColumns)} />
                ) : data.length > 0 ? (
                  data.map((user, i) => {
                    const isDeleted = Number(user?.is_delete) === 1;
                    return (
                      <tr
                        key={i}
                        className={isDeleted ? "deleted-user-row" : ""}
                      >
                        <td>{user?.sno ?? (page - 1) * perPage + i + 1}</td>
                        <td>
                          <Image
                            width={80}
                            height={80}
                            src={user?.profile_image || userIcon}
                            onError={(e) => {
                              e.target.src = userIcon;
                            }}
                            rounded
                          />
                        </td>
                        <td>{user?.member_id}</td>
                        <td>{user?.name}</td>
                        <td>
                          {formatPhoneWithCode(
                            user?.mobile_country_code,
                            user?.mobile_number,
                          )}
                        </td>
                        {/* <td>{user?.member_type_name}</td> */}
                        <td className="word-wrap">{user?.category_name}</td>
                        <td className="word-wrap">{user?.sub_category_name}</td>
                        <td>
                          {isDeleted ? (
                            <span className="badge bg-label-danger d-inline-flex align-items-center">
                              {/* <i className="bx bx-trash me-1" style={{ fontSize: "12px" }}></i> */}
                              Deleted
                            </span>
                          ) : (
                            user?.membership_status_text
                          )}
                        </td>
                        <td>{user?.date_of_joining}</td>
                        <td>{user?.membership_due_date}</td>
                        <td>{user?.is_welcome_email_sent_text}</td>
                        {hasRole([1]) && <td>{user?.country_name}</td>}
                        {hasRole([1, 6]) && <td>{user?.state_name}</td>}
                        {hasRole([1, 6, 7]) && <td>{user?.city_name}</td>}
                        {hasRole([1, 6, 7, 8]) && <td>{user?.region_name}</td>}
                        {hasRole([1, 6, 7, 8, 2]) && <td>{user?.chapter_name}</td>}
                        <td className="sticky-renewal-col" style={{ textAlign: "center" }}>
                          {!isDeleted ? (
                            <button
                              type="button"
                              className="badge bg-label-primary border-0 d-inline-flex align-items-center"
                              style={{
                                cursor: "pointer",
                                fontSize: "12px",
                                padding: "6px 10px",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Renew Membership"
                              data-bs-original-title="Renew Membership"
                              onClick={() => handleOpenRenewalModal(user)}
                            >
                              <i className="bx bx-refresh me-1" style={{ fontSize: "15px" }}></i>
                              Renew
                            </button>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="sticky-action-col" style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                          {isDeleted ? (
                            <>
                              <button
                                type="button"
                                className="badge bg-label-info me-1 border-0"
                                data-bs-toggle="tooltip"
                                data-bs-offset="0,4"
                                data-bs-placement="top"
                                data-bs-html="true"
                                title="View"
                                data-bs-original-title="View"
                                onClick={() => {
                                  setDetailModal(true);
                                  setDetailData(user);
                                  setMemberLogs([]);
                                  setShowMemberLogs(false);
                                  fetchMemberLogs(user?.id);
                                }}
                              >
                                <i className="bx bx-show"></i>
                              </button>
                              {hasPermission("members-edit") && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setConfirmationModal(true);
                                    setConfirmation({
                                      message: "Are you sure you want to restore this member?",
                                      fn: () => HandleRestore(user?.id),
                                    });
                                  }}
                                  className="badge bg-label-success border-0"
                                  data-bs-toggle="tooltip"
                                  data-bs-offset="0,4"
                                  data-bs-placement="top"
                                  data-bs-html="true"
                                  title="Restore"
                                  data-bs-original-title="Restore"
                                >
                                  <i className="bx bx-revision"></i>
                                </button>
                              )}
                            </>
                          ) : (
                            <>
                              {hasPermission("members-edit") && (
                                <button
                                  className="badge bg-label-warning me-1 border-0"
                                  data-bs-toggle="tooltip"
                                  data-bs-offset="0,4"
                                  data-bs-placement="top"
                                  data-bs-html="true"
                                  title="Change Circle"
                                  data-bs-original-title="Change Circle"
                                  onClick={() => {
                                    setChapterChangeModal(true);
                                    setForm({
                                      id: user?.id,
                                      name: user?.name,
                                      member_id: user?.member_id,
                                      company_name: user?.company_name,
                                      from_chapter_id: user?.chapter_id,
                                      from_chapter_id_selected: {
                                        value: Number(user?.chapter_id),
                                        label: user?.chapter_name,
                                      },
                                    });
                                  }}
                                >
                                  <i className="bx bx-refresh"></i>
                                </button>
                              )}

                              <button
                                className="badge bg-label-info me-1 border-0"
                                data-bs-toggle="tooltip"
                                data-bs-offset="0,4"
                                data-bs-placement="top"
                                data-bs-html="true"
                                title="View"
                                data-bs-original-title="View"
                                onClick={() => {
                                  setDetailModal(true);
                                  setDetailData(user);
                                  setMemberLogs([]);
                                  setShowMemberLogs(false);
                                  fetchMemberLogs(user?.id);
                                }}
                              >
                                <i className="bx bx-show"></i>
                              </button>

                              {hasPermission("members-edit") && (
                                <Link to={`/user/${user.id}/edit`}>
                                  <button
                                    className="badge bg-label-success me-1 border-0"
                                    data-bs-toggle="tooltip"
                                    data-bs-offset="0,4"
                                    data-bs-placement="top"
                                    data-bs-html="true"
                                    title="Edit"
                                    data-bs-original-title="Edit"
                                  >
                                    <i className="bx bx-pencil"></i>
                                  </button>
                                </Link>
                              )}
                              {hasPermission("members-delete") && (
                                <button
                                  onClick={() => {
                                    setConfirmationModal(true);
                                    setConfirmation({
                                      message: "Are you sure, you want to delete?",
                                      fn: () => HandleDelete(user?.id),
                                    });
                                  }}
                                  className="badge bg-label-danger border-0"
                                  data-bs-toggle="tooltip"
                                  data-bs-offset="0,4"
                                  data-bs-placement="top"
                                  data-bs-html="true"
                                  title="Delete"
                                  data-bs-original-title="Delete"
                                >
                                  <i className="bx bx-trash"></i>
                                </button>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <NoDataFound colspan={String(totalColumns)} message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#CF2030"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                if (typeof confirmation?.fn === "function") {
                  confirmation.fn();
                }
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={detailsModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Member Details{" "}
            <Image
              width={80}
              height={80}
              src={detailData?.profile_image || userIcon}
              onError={(e) => {
                e.target.src = userIcon;
              }}
              rounded
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Member ID</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.member_id)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Email</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.email)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Mobile Number</label>

                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(
                      formatPhoneWithCode(
                        detailData.mobile_country_code,
                        detailData.mobile_number,
                      ),
                    )}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">
                    Whatsapp Mobile Number
                  </label>

                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(
                      formatPhoneWithCode(
                        detailData.whatsapp_country_code,
                        detailData.whatsapp_mobile_number,
                      ),
                    )}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Company name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.company_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Address</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.address)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Bio Description</label>
                  <span
                    className="d-block font-weight-600"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {checkEmptyOrNull(detailData.bio_description)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">
                    Our Products and Services
                  </label>
                  <span
                    className="d-block font-weight-600"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {checkEmptyOrNull(detailData.our_products_and_services)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Date of Birth</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.dob)}
                  </span>
                </div>
              </div>

              {hasRole([1]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Country</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.country_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">State</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.state_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">City</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.city_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7, 8]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Region</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.region_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7, 8, 2]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Circle</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.chapter_name)}
                    </span>
                  </div>
                </div>
              )}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">User Role</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.user_role_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Category</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.category_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Sub Category</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.sub_category_name)}
                  </span>
                </div>
              </div>

              {/* Client: Crowns paused
              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Member Crowns</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.crowns_name)}
                  </span>
                </div>
              </div>
              */}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Payment Date</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.payment_date)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Payment Attachment</label>
                  <div className="mt-1">
                    {detailData?.payment_attachment ? (
                      detailData.payment_attachment.toLowerCase().endsWith(".pdf") ||
                      detailData.payment_attachment.toLowerCase().includes(".pdf") ? (
                        <a
                          href={detailData.payment_attachment}
                          target="_blank"
                          rel="noreferrer"
                          className="badge bg-label-danger text-decoration-none d-inline-flex align-items-center gap-1"
                          style={{ fontSize: "12px", padding: "6px 10px" }}
                        >
                          <i className="bx bxs-file-pdf font-size-14"></i> Open PDF in new tab
                        </a>
                      ) : (
                        <a
                          href={detailData.payment_attachment}
                          target="_blank"
                          rel="noreferrer"
                          title="View image"
                        >
                          <img
                            src={detailData.payment_attachment}
                            alt="Payment Attachment"
                            style={{
                              maxHeight: "80px",
                              maxWidth: "140px",
                              objectFit: "contain",
                              borderRadius: "6px",
                              border: "1px solid #cbd5e1",
                            }}
                          />
                        </a>
                      )
                    ) : (
                      <span className="d-block font-weight-600">-</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Date of Joining</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.date_of_joining)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Membership Duration (Years)</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.membership_duration_years)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Membership Due Date</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.membership_due_date)}
                  </span>
                </div>
              </div>

              {/* <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Membership Attachment</label>
                  <div className="mt-1">
                    {detailData?.membership_attachment ? (
                      detailData.membership_attachment.toLowerCase().endsWith(".pdf") ||
                      detailData.membership_attachment.toLowerCase().includes(".pdf") ? (
                        <a
                          href={detailData.membership_attachment}
                          target="_blank"
                          rel="noreferrer"
                          className="badge bg-label-danger text-decoration-none d-inline-flex align-items-center gap-1"
                          style={{ fontSize: "12px", padding: "6px 10px" }}
                        >
                          <i className="bx bxs-file-pdf font-size-14"></i> Open PDF in new tab
                        </a>
                      ) : (
                        <a
                          href={detailData.membership_attachment}
                          target="_blank"
                          rel="noreferrer"
                          title="View image"
                        >
                          <img
                            src={detailData.membership_attachment}
                            alt="Membership Attachment"
                            style={{
                              maxHeight: "80px",
                              maxWidth: "140px",
                              objectFit: "contain",
                              borderRadius: "6px",
                              border: "1px solid #cbd5e1",
                            }}
                          />
                        </a>
                      )
                    ) : (
                      <span className="d-block font-weight-600">-</span>
                    )}
                  </div>
                </div>
              </div> */}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Blood Group</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.blood_group_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">GST Number</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.gst)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Pan Number</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.pan)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Website</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.website)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Instagram Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.instagram_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Linkedin Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.linkedin_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Twitter Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.twitter_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Youtube Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.youtube_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Referred By</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.referred_by_text)}
                  </span>
                </div>
              </div>

              {detailData.referred_by === 3 && (
                <>
                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Referrer Name</label>
                      <span className="d-block font-weight-600">
                        {checkEmptyOrNull(detailData.referrer_name)}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Referrer Mobile</label>
                      <span className="d-block font-weight-600">
                        {checkEmptyOrNull(detailData.referrer_mobile)}
                      </span>
                    </div>
                  </div>
                </>
              )}

              {detailData.referred_by === 2 && (
                <>
                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Referrer Name</label>
                      <span className="d-block font-weight-600">
                        {checkEmptyOrNull(detailData.ref_member_name)} -{" "}
                        {checkEmptyOrNull(detailData.ref_member_region)} -{" "}
                        {checkEmptyOrNull(detailData.ref_member_chapter)}
                      </span>
                    </div>
                  </div>
                </>
              )}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Membership Status</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.membership_status_text)}
                  </span>
                </div>
              </div>

              {Number(detailData.membership_status) === 0 && (
                <>
                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Break Date & Time</label>
                      <span className="d-block font-weight-600">
                        {detailData.date_time
                          ? moment(detailData.date_time).format("DD-MM-YYYY HH:mm")
                          : "-"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Break Reason</label>
                      <span className="d-block font-weight-600">
                        {checkEmptyOrNull(detailData.reason)}
                      </span>
                    </div>
                  </div>
                </>
              )}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Welcome Email Sent</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.is_welcome_email_sent_text)}
                  </span>
                </div>
              </div>

              {/* Member Status Logs Section */}
              {showMemberLogs && (memberLogsLoading || (memberLogs && memberLogs.length > 0)) && (
                <div className="col-12 mt-3">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span style={{ fontWeight: "700", fontSize: "0.9rem", color: "#334155" }}>
                      <i className="bx bx-history me-1"></i> Member Status Logs
                    </span>
                    <button
                      type="button"
                      className="btn btn-link btn-sm p-0 text-decoration-none"
                      onClick={() => fetchMemberLogs(detailData?.id)}
                      disabled={memberLogsLoading}
                    >
                      <i className="bx bx-refresh me-1"></i>Refresh
                    </button>
                  </div>
                  {memberLogsLoading ? (
                    <div className="text-center py-3">
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <span className="ms-2 font-size-12 text-muted">Loading logs...</span>
                    </div>
                  ) : (
                    <div className="table-responsive" style={{ maxHeight: "300px", overflowY: "auto" }}>
                      <table className="table table-bordered table-hover mb-0" style={{ fontSize: "0.85rem" }}>
                        <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#f8f9fa" }}>
                          <tr>
                            <th className="text-nowrap">Sl.No</th>
                            <th className="text-nowrap">Type</th>
                            <th className="text-nowrap">Membership Status</th>
                            <th className="text-nowrap">Date & Time</th>
                            <th style={{ minWidth: "220px", maxWidth: "320px" }}>Reason</th>
                            <th className="text-nowrap">Category</th>
                            <th className="text-nowrap">Created By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {memberLogs.map((log, index) => (
                            <tr key={log.id || index}>
                              <td className="text-nowrap">{index + 1}</td>
                              <td className="text-nowrap">{renderMemberLogTypeBadge(log.type)}</td>
                              <td className="text-nowrap">
                                {Number(log.membership_status) === 1 ? (
                                  <span className="badge bg-success">Enable</span>
                                ) : (
                                  <span className="badge bg-danger">Disable</span>
                                )}
                              </td>
                              <td className="text-nowrap">
                                <div>
                                  {log.date_time
                                    ? moment(log.date_time).format("DD-MM-YYYY HH:mm")
                                    : "-"}
                                </div>
                                {getMemberBreakPeriodText(log, index, memberLogs) && (
                                  <small className="text-primary d-block fw-semibold" style={{ fontSize: "0.75rem", marginTop: "2px" }}>
                                    {getMemberBreakPeriodText(log, index, memberLogs)}
                                  </small>
                                )}
                              </td>
                              <td
                                style={{
                                  minWidth: "220px",
                                  maxWidth: "320px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                              >
                                {log.reason || "-"}
                              </td>
                              <td className="text-nowrap">{log.category_name || "-"}</td>
                              <td className="text-nowrap">{log.created_by_name || log.created_by || "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between align-items-center">
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
          {memberLogs && memberLogs.length > 0 && (
            <button
              type="button"
              className="btn btn-outline-info d-flex align-items-center"
              onClick={handleToggleMemberLogs}
            >
              <i className={`bx ${showMemberLogs ? "bx-hide" : "bx-show"} me-1`}></i>
              {showMemberLogs ? "Hide Logs" : "View Logs"}
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={chapterChangeModal}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setChapterChangeModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Change Circle
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="user_id">
                    Member<span className="text-danger">*</span>
                  </label>
                  <div>
                    {form?.name} - {form?.member_id} ({form?.company_name} )
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="from_chapter_id">
                    From Circle<span className="text-danger">*</span>
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="from_chapter_id"
                    isDisabled={true}
                    options={allChapterOptions}
                    value={form?.from_chapter_id_selected}
                    onChange={(selected) => {
                      setForm({
                        ...form,
                        from_chapter_id: selected?.value,
                      });
                    }}
                  />
                  <ValidationMessage error={errors} name="from_chapter_id" />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="to_chapter_id">
                    To Circle<span className="text-danger">*</span>
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="to_chapter_id"
                    isClearable
                    // options={allChapterOptions}
                    options={
                      Array.isArray(allChapterOptions)
                        ? allChapterOptions.filter(
                            (option) => option.value !== form.from_chapter_id,
                          )
                        : []
                    }
                    onChange={(selected) => {
                      setForm({
                        ...form,
                        to_chapter_id: selected?.value,
                      });
                    }}
                  />
                  <ValidationMessage error={errors} name="to_chapter_id" />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="chapter_changed_date">
                    Circle Changed Date<span className="text-danger">*</span>
                  </label>
                  <Flatpickr
                    className="form-control"
                    options={{
                      dateFormat: "d/m/Y",
                      enableTime: false,
                      maxDate: "today",
                    }}
                    onChange={(selected) =>
                      setForm({
                        ...form,
                        chapter_changed_date: moment(selected[0]).format(
                          "DD/MM/YYYY",
                        ),
                      })
                    }
                    value={detailData?.chapter_changed_date}
                    placeholder="Select Circle Changed Date"
                  />
                  <ValidationMessage
                    error={errors}
                    name="chapter_changed_date"
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-success isubmit_button"
            data-bs-dismiss="modal"
            disabled={btnDisabled}
            onClick={() => updateChapterSubmit(detailData?.id)}
          >
            Update
          </button>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setChapterChangeModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>


      <Modal
        show={importModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setImportModal(false);
          setImportFile(null);
          setPreviewData([]);
        }}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Import Members
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="import_file">
                    Upload Excel File<span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="import_file"
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                  />
                </div>
                <div className="mb-3">
                  <a
                    href={sampleExcel}
                    download="sample-members.xlsx"
                    className="text-primary text-decoration-underline d-inline-flex align-items-center"
                  >
                    <FaFileExcel className="me-2" /> Download Sample Excel
                  </a>
                </div>
              </div>
            </div>
            {previewData && previewData.length > 0 && (
              <div className="row mt-3">
                <div className="col-md-12">
                  <h6 className="mb-2">
                    Preview Data ({previewData.length} rows)
                  </h6>
                  <div
                    className="table-responsive"
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <table className="table table-striped itable">
                      <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                        <tr>
                          <th>S.No.</th>
                          <th>Image</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Mobile</th>
                        </tr>
                      </thead>
                      <tbody>
                        {previewData.map((row, index) => (
                          <tr key={index}>
                            <td className="align-middle">{index + 1}</td>
                            <td className="align-middle">
                              {row[5] ? (
                                <img
                                  src={getDriveImageUrl(row[5])}
                                  alt="Profile"
                                  referrerPolicy="no-referrer"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                  }}
                                />
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="align-middle">{getCellText(row[1])}</td>
                            <td className="align-middle">{getCellText(row[2])}</td>
                            <td className="align-middle">{getCellText(row[3])}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-success isubmit_button"
            style={{ minWidth: "120px" }}
            disabled={importLoading || btnDisabled}
            onClick={handleImportSubmit}
          >
            {importLoading ? "importing..." : "Import"}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            style={{ minWidth: "120px" }}
            data-bs-dismiss="modal"
            onClick={() => {
              setImportModal(false);
              setImportFile(null);
              setPreviewData([]);
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={emailModal}
        onHide={() => !emailLoading && setEmailModal(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header>
          <Modal.Title>Send Welcome Emails</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {emailStats ? (
            <div className="py-2">
              <h5 className="text-center mb-4 text-primary">
                {emailLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending Emails...
                  </>
                ) : emailStats.isDone ? (
                  <span className="text-success">Processing Complete</span>
                ) : (
                  <span className="text-info">Ready to Send</span>
                )}
              </h5>
              <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Total Needed to Send
                  <span className="badge bg-primary rounded-pill">
                    {emailStats.totalNeeded || 0}
                  </span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Total Sent Successfully
                  <span className="badge bg-success rounded-pill">
                    {emailStats.sentCount || 0}
                  </span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Total Failed
                  <span className="badge bg-danger rounded-pill">
                    {emailStats.failedCount || 0}
                  </span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Remaining Pending
                  <span className="badge bg-warning rounded-pill">
                    {emailStats.pendingCount || 0}
                  </span>
                </li>
              </ul>
            </div>
          ) : (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Starting process... please wait.</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {emailStats &&
            !emailLoading &&
            emailStats.pendingCount > 0 &&
            emailStats.sentCount === 0 &&
            emailStats.failedCount === 0 && (
              <button
                type="button"
                className="btn btn-success"
                style={{ minWidth: "120px" }}
                onClick={handleSendWelcomeEmails}
              >
                Send
              </button>
            )}
          <button
            type="button"
            className="btn btn-primary"
            style={{ minWidth: "120px" }}
            onClick={() => setEmailModal(false)}
            disabled={emailLoading}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      {/* Membership Renewal Modal */}
      <Modal
        show={renewalModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setRenewalModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton style={{ borderBottom: "1px solid #edf2f7", padding: "1.1rem 1.5rem" }}>
          <div>
            <Modal.Title id="contained-modal-title-vcenter" className="modal_title1 mb-1" style={{ fontSize: "1.25rem", fontWeight: "700", color: "#1e293b" }}>
              Membership renewal
            </Modal.Title>
            {renewalForm.chapter_name && (
              <div className="text-muted" style={{ fontSize: "0.85rem", fontWeight: "500" }}>
                {renewalForm.chapter_name}
              </div>
            )}
          </div>
        </Modal.Header>

        <Modal.Body className="p-4">
          {/* Member & Due Date Card */}
          <div
            className="mb-4"
            style={{ 
              border: "1px solid #e8edf3",
              borderRadius: "16px",
              padding: "18px 20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "12px",
              backgroundColor: "#fafbfc",
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  backgroundColor: "#fee2e2",
                  color: "#dc2626",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "700",
                  fontSize: "1.05rem",
                  flexShrink: 0,
                }}
              >
                {renewalForm.name
                  ? renewalForm.name
                      .split(" ")
                      .map((n) => n[0])
                      .slice(0, 2)
                      .join("")
                      .toUpperCase()
                  : "M"}
              </div>
              <div>
                <h6 className="mb-0" style={{ fontWeight: "700", fontSize: "1.05rem", color: "#0f172a" }}>
                  {renewalForm.name || "-"}
                </h6>
                <small className="text-muted" style={{ fontWeight: "500", fontSize: "0.85rem" }}>
                  {renewalForm.member_id || "-"}
                </small>
              </div>
            </div>

            <div className="text-end">
              <div className="text-muted mb-1" style={{ fontSize: "0.8rem", fontWeight: "500" }}>
                Current due date
              </div>
              <div style={{ fontSize: "0.95rem", fontWeight: "700", color: "#dc2626" }}>
                {renewalForm.current_due_date ? moment(renewalForm.current_due_date, ["DD/MM/YYYY", "DD-MM-YYYY", "DD/MM/YYYY"]).format("DD/MM/YYYY") : "Not Set"}
              </div>
            </div>
          </div>

          {/* Form Fields Section */}
          <div className="row">
            {/* Payment Date */}
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="payment_date">
                Payment Date<span className="text-danger">*</span>
              </label>
              <Flatpickr
                className="form-control"
                options={{
                  dateFormat: "d-m-Y",
                  enableTime: false,
                  maxDate: "today",
                }}
                value={renewalForm.payment_date}
                onChange={(selected) =>
                  handleRenewalFieldChange(
                    "payment_date",
                    moment(selected[0]).format("DD-MM-YYYY")
                  )
                }
                placeholder="DD-MM-YYYY"
              />
              {renewalErrors.payment_date && (
                <div className="text-danger mt-1 font-size-12">
                  {renewalErrors.payment_date}
                </div>
              )}
            </div>

            {/* Duration */}
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="membership_duration_years">
                Membership Duration (Years)<span className="text-danger">*</span>
              </label>
              <Select
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                name="membership_duration_years"
                options={[
                  { value: 1, label: "1 Year" },
                  { value: 2, label: "2 Years" },
                  { value: 3, label: "3 Years" },
                  { value: 5, label: "5 Years" },
                ]}
                value={[
                  { value: 1, label: "1 Year" },
                  { value: 2, label: "2 Years" },
                  { value: 3, label: "3 Years" },
                  { value: 5, label: "5 Years" },
                ].find(
                  (opt) => opt.value === renewalForm.membership_duration_years
                )}
                onChange={(selected) =>
                  handleRenewalFieldChange(
                    "membership_duration_years",
                    selected?.value || 1
                  )
                }
              />
              {renewalErrors.membership_duration_years && (
                <div className="text-danger mt-1 font-size-12">
                  {renewalErrors.membership_duration_years}
                </div>
              )}
            </div>

            {/* New membership valid until */}
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="new_due_date">
                New membership valid until
              </label>
              <input
                type="text"
                className="form-control"
                id="new_due_date"
                value={
                  renewalForm.new_due_date
                    ? moment(renewalForm.new_due_date, ["DD/MM/YYYY", "DD/MM/YYYY", "DD-MM-YYYY"]).format("DD/MM/YYYY")
                    : ""
                }
                disabled
                readOnly
                style={{ backgroundColor: "#f8f9fa", fontWeight: "600", color: "#334155" }}
              />
            </div>

            {/* Attachment */}
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="renewal_attachment">
                Attachment (Image/PDF)
              </label>
              <input
                type="file"
                className="form-control"
                id="renewal_attachment"
                accept="image/*,application/pdf"
                onChange={handleRenewalAttachmentChange}
              />
              <small className="text-muted" style={{ fontSize: "11px" }}>
                Allowed formats: Images (JPG, PNG, WEBP) & PDF (Max 10MB)
              </small>
              {renewalErrors.attachment && (
                <div className="text-danger mt-1 font-size-12">
                  {renewalErrors.attachment}
                </div>
              )}
              {renewalAttachmentPreview && (
                <div className="mt-2">
                  {renewalAttachmentType === "pdf" ? (
                    <a
                      href={renewalAttachmentPreview}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1"
                      style={{ borderRadius: "6px", fontSize: "12px", padding: "4px 10px" }}
                    >
                      <i className="ri-file-pdf-line font-size-16"></i> Open PDF in new tab
                    </a>
                  ) : (
                    <img
                      src={renewalAttachmentPreview}
                      alt="Attachment Preview"
                      style={{
                        maxHeight: "100px",
                        maxWidth: "100%",
                        objectFit: "contain",
                        borderRadius: "8px",
                        border: "1px solid #cbd5e1",
                        padding: "2px",
                        backgroundColor: "#fff",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      }}
                    />
                  )}
                </div>
              )}
            </div>

            {/* Notes */}
            <div className="col-12 mb-3">
              <label className="form-label" htmlFor="notes">
                Notes
              </label>
              <textarea
                className="form-control"
                id="notes"
                rows={3}
                placeholder="Any remarks about this renewal..."
                value={renewalForm.notes}
                onChange={(e) =>
                  handleRenewalFieldChange("notes", e.target.value)
                }
                style={{ borderRadius: "10px", resize: "vertical" }}
              ></textarea>
            </div>

            {/* View Renewal Logs Button */}
            <div className="col-12 mb-2">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1"
                onClick={handleToggleRenewalLogs}
                style={{ borderRadius: "8px", fontWeight: "600", fontSize: "0.82rem" }}
              >
                <i className={`ri-${showRenewalLogs ? "eye-off-line" : "history-line"}`}></i>
                {showRenewalLogs ? "Hide Renewal Logs" : "View Renewal Logs"}
              </button>
            </div>

            {/* Renewal Logs Table Section */}
            {showRenewalLogs && (
              <div className="col-12 mb-2">
                <div
                  style={{
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    backgroundColor: "#f8fafc",
                    padding: "12px",
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span style={{ fontWeight: "700", fontSize: "0.88rem", color: "#334155" }}>
                      Membership Renewal History
                    </span>
                    <button
                      type="button"
                      className="btn btn-link btn-sm p-0 text-decoration-none"
                      onClick={() => fetchRenewalLogs(renewalForm.user_id)}
                      disabled={renewalLogsLoading}
                      style={{ fontSize: "0.8rem" }}
                    >
                      <i className="ri-refresh-line me-1"></i>Refresh
                    </button>
                  </div>

                  {renewalLogsLoading ? (
                    <div className="text-center py-3">
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <span className="ms-2 font-size-12 text-muted">Loading renewal logs...</span>
                    </div>
                  ) : renewalLogs.length > 0 ? (
                    <div className="table-responsive" style={{ maxHeight: "200px" }}>
                      <table className="table table-bordered table-sm mb-0 align-middle bg-white" style={{ fontSize: "0.82rem" }}>
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Renewed On</th>
                            <th>Old Due Date</th>
                            <th>New Due Date</th>
                            <th>Duration</th>
                            <th>Renewed By</th>
                            <th>Attachment</th>
                            <th>Notes</th>
                          </tr>
                        </thead>
                        <tbody>
                          {renewalLogs.map((log, idx) => (
                            <tr key={log.id || idx}>
                              <td>{idx + 1}</td>
                              <td>
                                {log.renewed_on
                                  ? moment(log.renewed_on).format("DD/MM/YYYY hh:mm A")
                                  : log.created_at
                                  ? moment(log.created_at).format("DD/MM/YYYY hh:mm A")
                                  : "-"}
                              </td>
                              <td>
                                {log.old_due_date
                                  ? moment(log.old_due_date, ["DD/MM/YYYY", "DD-MM-YYYY", "DD/MM/YYYY"]).format("DD/MM/YYYY")
                                  : "-"}
                              </td>
                              <td className="text-success fw-bold">
                                {log.new_due_date
                                  ? moment(log.new_due_date, ["DD/MM/YYYY", "DD-MM-YYYY", "DD/MM/YYYY"]).format("DD/MM/YYYY")
                                  : "-"}
                              </td>
                              <td>
                                {log.duration_years ? `${log.duration_years} Year(s)` : "-"}
                              </td>
                              <td>{log.renewed_by_name || "Admin"}</td>
                              <td>
                                {log.attachment_url || log.attachment ? (
                                  (log.attachment_url || log.attachment).toLowerCase().endsWith(".pdf") ||
                                  (log.attachment_url || log.attachment).toLowerCase().includes(".pdf") ? (
                                    <a
                                      href={log.attachment_url || log.attachment}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="badge bg-label-danger text-decoration-none d-inline-flex align-items-center gap-1"
                                      style={{ fontSize: "11px" }}
                                      title="Open PDF in new tab"
                                    >
                                      <i className="ri-file-pdf-line"></i> Open PDF
                                    </a>
                                  ) : (
                                    <a
                                      href={log.attachment_url || log.attachment}
                                      target="_blank"
                                      rel="noreferrer"
                                      title="View image"
                                    >
                                      <img
                                        src={log.attachment_url || log.attachment}
                                        alt="Attachment"
                                        style={{
                                          width: "42px",
                                          height: "42px",
                                          objectFit: "cover",
                                          borderRadius: "6px",
                                          border: "1px solid #cbd5e1",
                                        }}
                                      />
                                    </a>
                                  )
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td style={{ maxWidth: "160px", wordBreak: "break-word" }}>
                                {log.remarks || "-"}
                              </td>
                               
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center text-muted py-3" style={{ fontSize: "0.82rem" }}>
                      No renewal history found for this member.
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #edf2f7", padding: "1rem 1.5rem", gap: "8px" }}>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setRenewalModal(false)}
            disabled={renewalSubmitting}
            style={{ borderRadius: "10px", minWidth: "100px" }}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-success isubmit_button"
            onClick={handleRenewalSubmit}
            disabled={renewalSubmitting}
            style={{ borderRadius: "10px", minWidth: "110px" }}
          >
            {renewalSubmitting ? "Submitting..." : "Submit"}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserList;
